module.exports = __webpack_public_path__ + "img/clover-icon-1.07035fc2.svg";